/** PC 顶栏频道导航（jackpot 由 useJackpotFeature 过滤，关开关时不出现） */
export const NAV_CHANNEL_LINKS = [
  {
    key: 'recommended',
    to: '/explore',
    labelKey: 'nav.channelRecommended',
    icon: 'forYou',
  },
  {
    key: 'sport',
    to: '/sport',
    labelKey: 'nav.sport',
    icon: 'sport',
  },
  {
    key: 'crypto',
    to: '/crypto',
    labelKey: 'nav.crypto',
    icon: 'crypto',
  },
  {
    key: 'leagues',
    to: '/leagues',
    labelKey: 'nav.leagues',
    icon: 'leagues',
  },
  {
    key: 'jackpot',
    to: '/jackpot',
    labelKey: 'nav.jackpot',
    icon: 'invite',
    feature: 'jackpot',
  },
  {
    key: 'invite',
    to: '/referrals',
    labelKey: 'nav.invite',
    icon: 'invite',
  },
];
